<button type="button" class="xp-back-button">
	<mat-icon *ngIf="icon()" class="xp-back-button__icon">{{ icon() }}</mat-icon>
	<img *ngIf="iconSrc()" class="xp-back-button__image" [src]="iconSrc()" alt="" />
	<span class="xp-back-button__label"><ng-content></ng-content></span>
</button>
